import { i18n } from '@ecloud/i18n'

export default i18n({ debug: import.meta.env.MODE === 'development' })
